import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import fetch from 'node-fetch';

import introspectionQueryResultData from './fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const link = new HttpLink({
  uri: process.env.REACT_APP_API_PLAYER_ENDPOINT,
  fetch,
});

const cache = new InMemoryCache({ fragmentMatcher });

const apolloClient = new ApolloClient({
  link,
  cache,
  fragmentMatcher,
});
export default apolloClient;
